import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { hasDST } from '@app/utilities/time';
import { DateTime } from '@lib/date-time';
import { firstValueFrom } from '@lib/rxjs';
import { Device, Shift, User } from '@models';
import { FragQueryService } from 'src/injectables/frag-query.service';

interface Input{
	record:Shift;
}

@Component({
  selector: 'app-shift',
  templateUrl: './shift-edit-dialog.component.html',
})
export class ShiftEditDialogComponent {
    static readonly config:MatDialogConfig<Input>={
		autoFocus: false,
		disableClose: true,
	};
	static readonly output:boolean;

	constructor(
		private readonly host:MatDialogRef<ShiftEditDialogComponent,boolean>,
		@Inject(MAT_DIALOG_DATA) private readonly input:Input,
        private fragQuery:FragQueryService,
		private user : User
	){};

	public record=this.input.record;
	public begin=this.record.beginDateTime??new DateTime();
	public end=this.record.endDateTime??new DateTime();
    public title=this.record.title;
	public emails=this.record.emails;
	public weighType:'area'|'volume'=this.record.weightType;
	public chartType:'column'|'line'=this.record.chartType;

	public valid(){
		if(!this.title)
			return false;
		return true;
	}

	public cancel(){
		this.host.close(false);
	}

	public async save() {
		const device: Device = await firstValueFrom(this.fragQuery.device$);
		if (!device) {
			console.error("Cannot save shift: device not available.");
			return;
		}
		this.record.siteId = this.user.siteId;
		this.record.emails = this.emails?.replace(/\s+/g, '') ?? '';
		this.record.begin = Math.floor(this.begin.valueOf() / 1000);
		this.record.end = Math.floor(this.end.valueOf() / 1000);
		this.record.title = this.title;
		this.record.deviceId = device.id;
		this.record.dst = hasDST();
		this.record.weightType = this.weighType;
		this.record.chartType = this.chartType;
		this.fragQuery.trigger$.next();
		this.host.close(true);
	}
}